const PREFIX = '/api/v1/integration/xeenia';

// `param` names the input field whose value fills the placeholder.
export const readEndpoints = [
    {
        key: 'catalog',
        label: 'Katalógus',
        method: 'GET',
        path: `${PREFIX}/catalog`,
        description: 'Publikált komponensek, paraméterek és referencialisták.',
    },
    {
        key: 'list',
        label: 'Referencialista',
        method: 'GET',
        path: `${PREFIX}/lists/{listKey}`,
        param: 'listKey',
        description: 'Egy referencialista kulcs szerint.',
    },
    {
        key: 'therapy',
        label: 'Terápia állapota',
        method: 'GET',
        path: `${PREFIX}/therapies/{externalRef}`,
        param: 'externalRef',
        description: 'Állapot, feladatszámok és adherencia a partner saját referenciájával.',
    },
];

export const writePaths = {
    store: `${PREFIX}/therapies`,
    show: `${PREFIX}/therapies/{externalRef}`,
    update: `${PREFIX}/therapies/{externalRef}`,
    lifecycle: `${PREFIX}/therapies/{externalRef}/lifecycle`,
};
